<template>
  <nav class="border-b border-orange-500 bg-gradient">
    <div
      class="container flex flex-col md:flex-row items-center justify-between mx-auto px-16 lg:px-32 xl:px-64 py-3"
    >
      <span class="cursor-pointer mb-3 md:mb-0 text-center md:text-left">
        <a href="/" aria-label="Home Page" class="text-2xl text-white font-semibold">
          QuoteGen
        </a>
        <p class="text-gray-50 text-sm">Generate random quote graphics</p>
      </span>

      <!-- Search Box -->
      <div class="w-full md:w-5/12">
        <search-box></search-box>
      </div>
    </div>
  </nav>
</template>

<script>
import SearchBox from "../Modules/SearchComponent.vue";

export default {
  name: "Header",
  components: { SearchBox },
};
</script>
<style scoped>
.bg-gradient {
  --gradient-to-color: #dd6b20;
  --gradient-from-color: #dd6b20;
  --gradient-via-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color),
    var(--gradient-to-color, rgba(237, 137, 54, 0));
  background-image: linear-gradient(to right, var(--gradient-color-stops));
}
</style>
